// Exact copy supplied by the program author — do not paraphrase.
// `short` is used in the pre-Session-1 intro popup.
// `body` is used in the permanent detail screen (Learn → BREATHE Framework in Detail).
export const BREATHE_FRAMEWORK = [
  {
    key: "b_bring_on_board",
    letter: "B",
    title: "Bring Them On Board",
    short: "your child's buy-in and tribe identity",
    body: "This might be the most important part of the entire process — if we can't get our kids to buy in and want to participate, nothing else will matter. This is why the Thrive Tribe, Nasal Ninja, and Myo Princess groups exist — to give your child purpose and a story to step into.",
  },
  {
    key: "r_recognize_assess",
    letter: "R",
    title: "Recognize and Assess",
    short: "understanding the specific symptoms at play",
    body: "Before we can make progress, we have to understand where we're starting. This is about seeing what's really going on beneath the surface — not just symptoms, but why they're happening — so we know exactly what we're working toward.",
  },
  {
    key: "e_eliminate_barriers",
    letter: "E",
    title: "Eliminate Barriers",
    short: "clearing what's in the way — structural (like tongue tie) and scheduling (like busyness)",
    body: "What gets in the way of progress isn't always the same for every family. Sometimes it's structural — something like a tongue tie or another roadblock we need to work around or address. Sometimes it's scheduling and mindset — busyness, self-doubt, or just not having a plan yet. This step is about clearing both kinds of barriers: planning for success with a start date and realistic scheduling, and staying alert to any structural roadblocks that might need extra attention along the way.",
  },
  {
    key: "a_activate_passive",
    letter: "A",
    title: "Activate Passive Reprogramming",
    short: "building habits throughout the day",
    body: "This is where change starts to stick — through passive reprogramming, also called neuromuscular reeducation. These are the exercises that build muscle memory so the body can do the right thing without thinking about it.",
  },
  {
    key: "t_train_strength",
    letter: "T",
    title: "Train Strength and Function",
    short: "active, guided exercises",
    body: "Habits are only helpful if the body has the strength to carry them out. This is where active exercises come in — building the muscles in the tongue, lips, cheeks, and jaw so those new habits actually stick.",
  },
  {
    key: "h_harness_daily",
    letter: "H",
    title: "Harness Daily Practice",
    short: "consistency — progress, not perfection",
    body: "This is the hard part — the actual practicing. But we're aiming for progress, not perfection. Missed days don't disqualify you; what matters is coming back and picking up where you left off.",
  },
  {
    key: "e_elevate_breathing",
    letter: "E",
    title: "Elevate Breathing For Life",
    short: "graduation and lifelong maintenance",
    body: "This is where everything you've worked for gets protected long-term — a plan to maintain progress, whether that means continued exercises, an appliance, or other next steps, so results don't stop when the program ends.",
  },
];
